module.exports = __webpack_public_path__ + "static/media/IMG-33.2f24f904.jpg";